import Search from './Search';
import StockCard from './StockCard';
import { fetchQuotes } from './Quote';
import { useState, useEffect, useRef } from 'react';
import './stocks.css';

const Stocks = () => {
  const ratingBtnRef = useRef(null);

  const [tickers, setTickers] = useState(
    JSON.parse(localStorage.getItem('StockTickers')) || []
  );
  const [quotes, setQuotes] = useState({});

  // Keep stocks as a derived state (tickers + quotes)
  const [stocks, setStocks] = useState([]);

  const arrayIncludesObject = (arr, key, valueToCheck) => {
    return arr.some((value) => value[key] === valueToCheck);
  };

  const arrayFindIndex = (arr, key, valueToCheck) => {
    return arr.findIndex((value) => value[key] === valueToCheck);
  };

  // Sync tickers to local storage and fetch quotes
  useEffect(() => {
    localStorage.setItem('StockTickers', JSON.stringify(tickers));

    if (tickers && tickers.length > 0) {
      fetchAndUpdateQuotes(tickers);
    }
  }, [tickers]);

  const newStock = (stock) => {
    if (!stock) return;

    const existsInStocks = arrayIncludesObject(stocks, 'ticker', stock.Ticker);

    if (existsInStocks) {
      let idx = arrayFindIndex(stocks, 'ticker', stock.Ticker);
      console.log('stock exists at ' + idx);
    } else {
      const newStockObj = {
        ticker: stock.Ticker,
        company: stock.companyName,
        price: +stock.Price,
        changeUSD: +stock.ChangeUSD,
        rating: +stock.Rating,
        score: +stock.AppScore,
        growth: +stock.GrowthScore,
        valuation: +stock.ValuationScore,
        profitability: +stock.ProfitabilityScore,
        strength: +stock.StrengthScore,
        sentiment: +stock.SentimentScore,
        momentum: +stock.MomentumScore
      };

      setStocks((prev) => [...prev, newStockObj]);
    }
  };

  const handleAddChild = (name) => {
    if (!tickers.includes(name)) {
      setTickers([...tickers, name]);
    } else {
      console.log('Ticker already in the list - do nothing');
    }
  };

  const handleRemoveChild = (name) => {
    setTickers(tickers.filter((item) => item !== name));
    setStocks((prev) => prev.filter((item) => item.ticker !== name));

    console.log('Removing ' + name);
  };

  const handleClick = (order) => {
    const sorted = [...stocks];

    const compare = (key) => (a, b) => (a[key] < b[key] ? 1 : -1);

    switch (order) {
      case 'rating':
        ratingBtnRef.current.focus();
        sorted.sort(
          (a, b) =>
            a.rating < b.rating || (a.rating === b.rating && a.score < b.score)
              ? 1
              : -1
        );
        break;
      case 'score':
      case 'growth':
      case 'valuation':
      case 'profitability':
      case 'strength':
      case 'sentiment':
      case 'momentum':
        sorted.sort(compare(order));
        break;
      default:
        sorted.sort((a, b) => (a.ticker < b.ticker ? 1 : -1));
        break;
    }

    setStocks(sorted);
    setTickers(sorted.map((s) => s.ticker));
  };

  const fetchAndUpdateQuotes = async (symbols) => {
    try {
      const quoteArray = await fetchQuotes(symbols);
      const quotesMap = {};
      quoteArray.forEach((q) => {
        quotesMap[q.ticker] = {
          price: q.Price,
          change: q.ChangeUSD
        };
      });

      setQuotes(quotesMap);

      // Merge quotes into stocks
      setStocks((prev) =>
        prev.map((stock) => ({
          ...stock,
          price: quotesMap[stock.ticker]?.price || stock.price,
          changeUSD: quotesMap[stock.ticker]?.change || stock.changeUSD
        }))
      );
    } catch (err) {
      console.error('Error fetching quotes:', err);
    }
  };

  return (
    <div className="content">
      <div className="stocks" align="center">
        <Search handler={handleAddChild} />
        <>
          <i>Sort Options: </i>
          <button
            onClick={() => handleClick('rating')}
            value="Rating"
            ref={ratingBtnRef}
          >
            Rating
          </button>
          <button onClick={() => handleClick('growth')} value="Growth">
            Growth
          </button>
          <button onClick={() => handleClick('valuation')} value="Valuation">
            Valuation
          </button>
          <button
            onClick={() => handleClick('profitability')}
            value="Profitability"
          >
            Profitability
          </button>
          <button onClick={() => handleClick('strength')} value="Strength">
            Strength
          </button>
          <button onClick={() => handleClick('momentum')} value="Momentum">
            Momentum
          </button>
          <p></p>
        </>
        {tickers.map((item) => (
          <StockCard
            key={item}
            ticker={item}
            setStockData={newStock}
            handleRemove={handleRemoveChild}
            price={quotes[item]?.price || '-'}
            change={quotes[item]?.change || '-'}
          />
        ))}
      </div>
    </div>
  );
};

export default Stocks;
